export default "__VITE_ASSET__9qqF82DF__"